import { ChangeEvent, FC } from 'react';
import NubmerFormat, {
  NumberFormatProps,
  NumberFormatValues,
  SyntheticInputEvent
} from 'react-number-format';

type InputNumberProps = NumberFormatProps & {
  name: string;
  value: any;
  disabled?: boolean;
  decimalScale?: number;
  fixedDecimalScale?: boolean;
  pattern?: string;
  onChange?(event: ChangeEvent<any>): void;
};

const normalizedChange =
  (onChange: (e: ChangeEvent<any>) => void) =>
  (
    { floatValue }: NumberFormatValues,
    { target: { name } }: SyntheticInputEvent
  ) => {
    const value = !floatValue ? '' : floatValue;
    onChange({ target: { name, value } } as ChangeEvent<any>);
  };

const InputNumber: FC<InputNumberProps> = ({
  name,
  value,
  onChange,
  disabled,
  decimalScale = 2,
  fixedDecimalScale = true,
  pattern,
  ...props
}) => {
  return (
    <NubmerFormat
      id={name}
      name={name}
      value={value}
      decimalSeparator=","
      thousandSeparator="."
      decimalScale={decimalScale}
      fixedDecimalScale={fixedDecimalScale}
      pattern={pattern}
      disabled={disabled}
      onValueChange={onChange && normalizedChange(onChange)}
      {...props}
    />
  );
};

export { InputNumber };
